 import React from 'react';  
import {ProjectHeading} from '../../components/Comp/AllComponents';
import './Project.css' ;
import { Toolbar } from '@mui/material';
import Pro from '../../components/Pro/Pro';
 
 
 
 const Project = () => {
   return (
     <>
     <Toolbar />
     <ProjectHeading />  
     <div className="Project">
     <Pro />
</div>
      
     </>
   )
 }
 
 export default Project
 
 
 
//  export const ProjectImg = [
//   {
//     name:'MERN OTP Login',
//     image:{OtpLogin},
//     details:'The OTP Login Web Application project aims to create a secure and user-friendly web-based authentication system using  (OTPs). '
//   },
//   {
//     name:'MERN Google Login',
//     image:'/client/src/images/signup with mern.png',
//     details:'The OTP Login Web Application project aims to create a secure and user-friendly web-based authentication system using  (OTPs). '
//   },
//   {
//     name:'MERN roomlo Login',
//     image:'/client/src/images/roomlo.png',
//     details:'The OTP Login Web Application project aims to create a secure and user-friendly web-based authentication system using  (OTPs). '
//   },
// ]





// {/*<Typography
//         className='container'
//         variant='div'
//         component={'div'}
//       >
//         <Typography
//           className=' project'
//           variant='div'
//           component={'div'}
//         >
//           <Typography 
//       className='contactHeading' 
//       variant='h3' sx={{ 
//         textAlign: 'center' ,
//         ml:2,
//         mr:4,
//         mb:4
//         }}>
//         Projects
//       </Typography>
//           <Typography
//             className='all-items'
//             variant='div'
//             component={'div'} 
//           >
//             {/* first item */}
//             {/* <Typography
//               className='item'
//               variant='div'
//               component={'div'}
//               sx={{
//                 justifyContent:'center'
//               }}
//             >
//               <Typography
//                 className='left'
//                 variant='div'
//                 component={'div'}
//               >
//                 <Typography
//                   className='img'
//                   variant='div' 
//                   component={'div'}
//                   sx={{
//                     height:"400px",
//                     width:'400px'
//                   }}
//                 >
//                   <img className='imgp' src={Roomlo} alt="project pic" />
//                 </Typography>
//               </Typography>

//               <Typography
//                 className='right'
//                 variant='div'
//                 component={'div'}
//               >
//                 <Typography
//                   className='h5'
//                   variant='h5'
//                   component={'h5'}
//                 >
//                   Roomlo
//                 </Typography>
//                 <Typography 
//                 className='projectPara'
//                   variant='p'
//                   component={'p'}
//                   sx={{
//                     justifyContent:'space-around',
//                     width:'100%',
//                     pl:2,
//                     wordSpacing:'2px'                               
//                   }}
//                 >
// The Room Rental Platform project aims to create a web application that facilitates the rental and management of rooms or properties. Users, both property owners and tenants, can interact on this platform to find, list, and manage rental accommodations. The application will provide a user-friendly interface for property listings, search functionalities, secure user authentication, and features to streamline the rental process.                </Typography>
//                 <Typography
//                   className='Buttons'
//                   variant='div'
//                   component={'div'}
//                   sx={{
//                     display:'flex',
//                     gap:'20px',
//                     pl:3,
//                     mb:2
//                   }}
//                 >
                  
//                   <Button
//                   size='small'
//                   variant='contained'
//                   className='home_btn btn1'
//                   sx={{
//                     backgroundColor: '#138781',
//                     fontSize: 18, mt: 4,
//                     overflow:'hidden'
//                   }}
//                   >
//                     <NavLink
//                     sx={{
//                       textDecoration: 'none',
//                     }}
//                   >knowmore</NavLink></Button>
//                   <Button
//                   size='small'
//                   variant='outlined'
//                   className=' btn2'
//                   sx={{
//                     backgroundColor: '#57059b',
//                     fontSize: 18, 
//                     mt: 4,
                                       
//                   }}
//                   >
//                     <NavLink
//                     sx={{
//                       textDecoration: 'none',
//                       color:'#fff' 
//                     }}
//                   >preview</NavLink>
//                   </Button>
//                 </Typography>
//               </Typography>
//             </Typography> */}



//             {/* second project */}
//             {/* <Typography
//               className='item'
//               variant='div'
//               component={'div'}
//               sx={{
//                 justifyContent:'center'
//               }}
//             >
//               <Typography
//                 className='left'
//                 variant='div'
//                 component={'div'}
//               >
//                 <Typography
//                   className='img'
//                   variant='div'
//                   height="300"
//                   width={300}
//                   component={'div'}
//                   sx={{
//                     height:"300px",
//                     width:'300px'
//                   }}
//                 >
//                   <img className='imgp' src={OtpLogin} alt="project pic" />
//                 </Typography>
//               </Typography>

//               <Typography
//                 className='right'
//                 variant='div'
//                 component={'div'}
//               >
//                 <Typography
//                   className='h5'
//                   variant='h5'
//                   component={'h5'}
//                 >
//                   MERN-Login-with-google
//                 </Typography>
//                 <Typography
//                   className='projectPara'
//                   variant='p'
//                   component={'p'}
//                   sx={{
//                     justifyContent:'space-between',
//                     width:'100%',
//                     pl:2,
//                     wordSpacing:'2px'                    
//                   }}
//                 >
//                   The OTP Login Web Application project aims to create a secure and user-friendly web-based authentication system using  (OTPs). Instead of traditional password-based logins, this system will rely on temporary codes sent to users via SMS or email for enhanced security.  
//                 </Typography>
//                 <Typography
//                   className='Buttons'
//                   variant='div'
//                   component={'div'}
//                   sx={{
//                     display:'flex',
//                     gap:'20px',
//                     pl:3,
//                     mb:2
//                   }}
//                 >
                  
//                   <Button
//                   size='small'
//                   variant='contained'
//                   className='home_btn btn1'
//                   sx={{
//                     backgroundColor: '#138781',
//                     fontSize: 18, mt: 4,
//                     overflow:'hidden'
//                   }}
//                   >
//                     <NavLink
//                     sx={{
//                       textDecoration: 'none',
//                     }}
//                   >knowmore</NavLink></Button>
//                   <Button
//                   size='small'
//                   variant='outlined'
//                   className=' btn2'
//                   sx={{
//                     backgroundColor: '#360161',
//                     fontSize: 18, 
//                     mt: 4,
                                       
//                   }}
//                   >
//                     <NavLink
//                     sx={{
//                       textDecoration: 'none',
//                       color:'#fff' 
//                     }}
//                   >preview</NavLink>
//                   </Button>
//                 </Typography>
//               </Typography>
//             </Typography> */}

//             {/* thard project */}
//             {/* <Typography
//               className='item'
//               variant='div'
//               component={'div'}
//               sx={{
//                 justifyContent:'center'
//               }}
//             >
//               <Typography
//                 className='left'
//                 variant='div'
//                 component={'div'}
//               >
//                 <Typography
//                   className='img'
//                   variant='div'
//                   height="300"
//                   width={300}
//                   component={'div'}
//                   sx={{
//                     height:"300px",
//                     width:'300px'
//                   }}
//                 >
//                   <img className='imgp' src={GoogleLogin} alt="project pic" />
//                 </Typography>
//               </Typography>

//               <Typography
//                 className='right'
//                 variant='div'
//                 component={'div'}
//               >
//                 <Typography
//                   className='h5'
//                   variant='h5'
//                   component={'h5'}
//                 >
//                   MERN-Login-with-google
//                 </Typography>
//                 <Typography
//                   className='projectPara'
//                   variant='p'
//                   component={'p'}
//                   sx={{
//                     justifyContent:'space-between',
//                     width:'100%',
//                     pl:2,
//                     wordSpacing:'2px'                    
//                   }}
//                 >
//                   This project aims to enhance the user experience of a blog platform by integrating Google Sing-In. Users will have the option to log in using their Google accounts, providing a seamless and secure authentication process.                 
//                 </Typography>
//                 <Typography
//                   className='Buttons'
//                   variant='div'
//                   component={'div'}
//                   sx={{
//                     display:'flex',
//                     gap:'20px',
//                     pl:3,
//                     mb:2
//                   }}
//                 >
                  
//                   <Button
//                   size='small'
//                   variant='contained'
//                   className='home_btn btn1'
//                   sx={{
//                     backgroundColor: '#138781',
//                     fontSize: 18, mt: 4,
//                     overflow:'hidden'
//                   }}
//                   >
//                     <NavLink
//                     sx={{
//                       textDecoration: 'none',
//                     }}
//                   >knowmore</NavLink></Button>
//                   <Button
//                   size='small'
//                   variant='outlined'
//                   className=' btn2'
//                   sx={{
//                     backgroundColor: '#360161',
//                     fontSize: 18, 
//                     mt: 4,
                                       
//                   }}
//                   >
//                     <NavLink
//                     sx={{
//                       textDecoration: 'none',
//                       color:'#fff' 
//                     }}
//                   >preview</NavLink>
//                   </Button>
//                 </Typography>
//               </Typography>
//             </Typography> */}





//           {/* </Typography>*all-items */}
//         {/* </Typography> */}
//       {/* </Typography>*/} 